// Khyati Portal — RSR International design tokens.
export const C = {
  sidebar: '#2D2C72',
  navy: '#3B3A8F',
  red: '#E22D2D',
  pageBg: '#F7F6F3',
  card: '#FFFFFF',
  text: '#1C1C1C',
  textMuted: '#6B6B6B',
  border: '#E8E7E7',
  success: '#1D9E75',
  warning: '#BA7517',
};

export const FONT = "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif";
